var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _g, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMarineopenpolicyicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 83,
    height: 74,
    viewBox: "0 0 83 74",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.173 28.7012H4.24146V38.6297H33.173V28.7012Z",
    fill: "#585A5B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M39.7535 28.7012H19.1418V38.1918H39.7535V28.7012Z",
    fill: "#6A6C6D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2706 30.5605H6.33057V34.1531H10.2706V30.5605Z",
    fill: "#414142"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2877 30.5605H6.79175V34.1531H10.2877V30.5605Z",
    fill: "#7E7E7F"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0446 30.5605H12.1042V34.1531H16.0446V30.5605Z",
    fill: "#414142"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0614 30.5605H12.5654V34.1531H16.0614V30.5605Z",
    fill: "#7E7E7F"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M25.9777 30.5605H22.0374V34.1531H25.9777V30.5605Z",
    fill: "#414142"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M25.9944 30.5605H22.4988V34.1531H25.9944V30.5605Z",
    fill: "#7E7E7F"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M31.7513 30.5605H27.8113V34.1531H31.7513V30.5605Z",
    fill: "#414142"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M31.7686 30.5605H28.2727V34.1531H31.7686V30.5605Z",
    fill: "#7E7E7F"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M64.8568 24.291H52.3572V31.4176H64.8568V24.291Z",
    fill: "#E74600"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M71.2746 24.291H64.8572V31.4176H71.2746V24.291Z",
    fill: "#FF6B00"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M53.0226 24.5293H52.7849V31.4175H53.0226V24.5293Z",
    fill: "#C43402"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M53.8782 24.5293H53.6409V31.4175H53.8782V24.5293Z",
    fill: "#C43402"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M55.0186 24.5293H54.7812V31.4175H55.0186V24.5293Z",
    fill: "#C43402"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M56.1603 24.5293H55.9219V31.4175H56.1603V24.5293Z",
    fill: "#C43402"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M57.5859 24.5293H57.3481V31.4175H57.5859V24.5293Z",
    fill: "#C43402"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M59.0109 24.5293H58.7739V31.4175H59.0109V24.5293Z",
    fill: "#C43402"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M60.7226 24.5293H60.4856V31.4175H60.7226V24.5293Z",
    fill: "#C43402"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M62.1486 24.5293H61.9109V31.4175H62.1486V24.5293Z",
    fill: "#C43402"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M63.8596 24.5293H63.6226V31.4175H63.8596V24.5293Z",
    fill: "#C43402"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M66.1413 24.5293H65.9036V31.4175H66.1413V24.5293Z",
    fill: "#EF6203"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M67.5663 24.5293H67.3286V31.4175H67.5663V24.5293Z",
    fill: "#EF6203"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M68.9926 24.5293H68.7556V31.4175H68.9926V24.5293Z",
    fill: "#EF6203"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M70.4189 24.5293H70.1812V31.4175H70.4189V24.5293Z",
    fill: "#EF6203"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M71.2798 24.125H64.8452V24.5441H71.2798V24.125Z",
    fill: "#CD5A0D"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M64.8453 24.125H52.345V24.5535H64.8453V24.125Z",
    fill: "#B7520D"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M64.8453 31.252H52.345V31.6794H64.8453V31.252Z",
    fill: "#B7520D"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M71.2712 31.252H64.8367V31.6704H71.2712V31.252Z",
    fill: "#CD5A0D"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M56.4417 18.1406H45.9097V24.145H56.4417V18.1406Z",
    fill: "#0C83FD"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M61.8481 18.1406H56.4414V24.145H61.8481V18.1406Z",
    fill: "#59B8E7"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M46.2297 18.3398H46.0293V24.1439H46.2297V18.3398Z",
    fill: "#0F79D8"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M46.9504 18.3398H46.75V24.1439H46.9504V18.3398Z",
    fill: "#0F79D8"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M47.9108 18.3398H47.7114V24.1439H47.9108V18.3398Z",
    fill: "#0F79D8"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M48.8725 18.3398H48.6721V24.1439H48.8725V18.3398Z",
    fill: "#0F79D8"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M50.074 18.3398H49.8743V24.1439H50.074V18.3398Z",
    fill: "#0F79D8"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M51.2752 18.3398H51.0762V24.1439H51.2752V18.3398Z",
    fill: "#0F79D8"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M52.7171 18.3398H52.5173V24.1439H52.7171V18.3398Z",
    fill: "#0F79D8"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M53.919 18.3398H53.7192V24.1439H53.919V18.3398Z",
    fill: "#0F79D8"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M55.3602 18.3398H55.1602V24.1439H55.3602V18.3398Z",
    fill: "#0F79D8"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M57.5226 18.3398H57.3232V24.1439H57.5226V18.3398Z",
    fill: "#48A6CC"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M58.7249 18.3398H58.5242V24.1439H58.7249V18.3398Z",
    fill: "#48A6CC"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M59.9264 18.3398H59.7263V24.1439H59.9264V18.3398Z",
    fill: "#48A6CC"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M61.1271 18.3398H60.9277V24.1439H61.1271V18.3398Z",
    fill: "#48A6CC"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M61.8531 18H56.4321V18.3533H61.8531V18Z",
    fill: "#2769A0"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M56.4322 18H45.8994V18.3602H56.4322V18Z",
    fill: "#205B95"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M56.4322 24.0039H45.8994V24.3641H56.4322V24.0039Z",
    fill: "#205B95"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M61.8463 24.0039H56.4243V24.3568H61.8463V24.0039Z",
    fill: "#2769A0"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M75.3608 31.2266H62.4102V37.6173H75.3608V31.2266Z",
    fill: "#46556B"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M82.0083 31.2266H75.3608V37.6173H82.0083V31.2266Z",
    fill: "#506A89"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M62.804 31.4395H62.5576V37.6173H62.804V31.4395Z",
    fill: "#3B495B"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M63.6903 31.4395H63.4446V37.6173H63.6903V31.4395Z",
    fill: "#3B495B"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M64.8722 31.4395H64.6265V37.6173H64.8722V31.4395Z",
    fill: "#3B495B"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M66.0535 31.4395H65.8081V37.6173H66.0535V31.4395Z",
    fill: "#3B495B"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M67.5308 31.4395H67.2854V37.6173H67.5308V31.4395Z",
    fill: "#3B495B"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M69.0089 31.4395H68.7632V37.6173H69.0089V31.4395Z",
    fill: "#3B495B"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M70.7808 31.4395H70.5354V37.6173H70.7808V31.4395Z",
    fill: "#3B495B"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M72.2586 31.4395H72.0122V37.6173H72.2586V31.4395Z",
    fill: "#3B495B"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M74.0311 31.4395H73.7854V37.6173H74.0311V31.4395Z",
    fill: "#3B495B"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M76.6904 31.4395H76.4443V37.6173H76.6904V31.4395Z",
    fill: "#577CA0"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M78.1677 31.4395H77.9216V37.6173H78.1677V31.4395Z",
    fill: "#577CA0"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M79.6448 31.4395H79.3987V37.6173H79.6448V31.4395Z",
    fill: "#577CA0"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M81.1223 31.4395H80.877V37.6173H81.1223V31.4395Z",
    fill: "#577CA0"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M82.0146 31.0781H75.3486V31.4533H82.0146V31.0781Z",
    fill: "#3E4E5E"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M75.3486 31.0781H62.3979V31.4617H75.3486V31.0781Z",
    fill: "#394656"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M75.3486 37.4688H62.3979V37.8527H75.3486V37.4688Z",
    fill: "#394656"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M82.0063 37.4688H75.3396V37.8447H82.0063V37.4688Z",
    fill: "#3E4E5E"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M63.1039 38.3491L50.0518 38.3027L49.9832 38.4727H63.1011L63.1039 38.3491Z",
    fill: "black"
  }))), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M62.6172 53.5449H10.7446C11.426 54.9329 12.1726 55.7387 12.609 56.1282H62.6444C62.535 55.2077 62.5444 54.3344 62.6172 53.5449Z",
    fill: "#BEBEBF"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M37.4004 30.5605H33.4604V34.1531H37.4004V30.5605Z",
    fill: "#414142"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M37.4175 30.5605H33.9219V34.1531H37.4175V30.5605Z",
    fill: "#7E7E7F"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M42.7503 30.8691H30.2507V37.996H42.7503V30.8691Z",
    fill: "#E74600"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M49.1673 30.8691H42.7502V37.996H49.1673V30.8691Z",
    fill: "#FF6B00"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M30.9154 31.1074H30.6777V37.996H30.9154V31.1074Z",
    fill: "#C43402"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M31.7711 31.1074H31.5337V37.996H31.7711V31.1074Z",
    fill: "#C43402"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M32.9118 31.1074H32.6748V37.996H32.9118V31.1074Z",
    fill: "#C43402"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0531 31.1074H33.8147V37.996H34.0531V31.1074Z",
    fill: "#C43402"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M35.4789 31.1074H35.2412V37.996H35.4789V31.1074Z",
    fill: "#C43402"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M36.9044 31.1074H36.667V37.996H36.9044V31.1074Z",
    fill: "#C43402"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M38.6155 31.1074H38.3782V37.996H38.6155V31.1074Z",
    fill: "#C43402"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M40.0421 31.1074H39.8037V37.996H40.0421V31.1074Z",
    fill: "#C43402"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M41.7521 31.1074H41.5151V37.996H41.7521V31.1074Z",
    fill: "#C43402"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M44.034 31.1074H43.7966V37.996H44.034V31.1074Z",
    fill: "#EF6203"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M45.4599 31.1074H45.2222V37.996H45.4599V31.1074Z",
    fill: "#EF6203"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M46.8854 31.1074H46.6484V37.996H46.8854V31.1074Z",
    fill: "#EF6203"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M48.3118 31.1074H48.0745V37.996H48.3118V31.1074Z",
    fill: "#EF6203"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M49.1737 30.7031H42.7388V31.1222H49.1737V30.7031Z",
    fill: "#CD5A0D"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M42.7384 30.7031H30.2378V31.1316H42.7384V30.7031Z",
    fill: "#B7520D"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M42.7384 37.8301H30.2378V38.2575H42.7384V37.8301Z",
    fill: "#B7520D"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M49.1642 37.8301H42.73V38.2485H49.1642V37.8301Z",
    fill: "#CD5A0D"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M59.0678 31.1992H46.4971V38.3658H59.0678V31.1992Z",
    fill: "#0C83FD"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M65.5206 31.1992H59.0676V38.3658H65.5206V31.1992Z",
    fill: "#59B8E7"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M46.8792 31.4375H46.6401V38.3655H46.8792V31.4375Z",
    fill: "#0F79D8"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M47.7396 31.4375H47.5005V38.3655H47.7396V31.4375Z",
    fill: "#0F79D8"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M48.8866 31.4375H48.6482V38.3655H48.8866V31.4375Z",
    fill: "#0F79D8"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M50.034 31.4375H49.7949V38.3655H50.034V31.4375Z",
    fill: "#0F79D8"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M51.4678 31.4375H51.229V38.3655H51.4678V31.4375Z",
    fill: "#0F79D8"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M52.9015 31.4375H52.6631V38.3655H52.9015V31.4375Z",
    fill: "#0F79D8"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M54.6229 31.4375H54.3838V38.3655H54.6229V31.4375Z",
    fill: "#0F79D8"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M56.0565 31.4375H55.8181V38.3655H56.0565V31.4375Z",
    fill: "#0F79D8"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M57.7778 31.4375H57.5391V38.3655H57.7778V31.4375Z",
    fill: "#0F79D8"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M60.3585 31.4375H60.1201V38.3655H60.3585V31.4375Z",
    fill: "#48A6CC"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M61.7925 31.4375H61.5537V38.3655H61.7925V31.4375Z",
    fill: "#48A6CC"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M63.227 31.4375H62.9883V38.3655H63.227V31.4375Z",
    fill: "#48A6CC"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M64.6606 31.4375H64.4229V38.3655H64.6606V31.4375Z",
    fill: "#48A6CC"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M65.5266 31.0332H59.0562V31.4544H65.5266V31.0332Z",
    fill: "#2769A0"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M59.0562 31.0332H46.4851V31.4631H59.0562V31.0332Z",
    fill: "#205B95"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M59.0562 38.1992H46.4851V38.6291H59.0562V38.1992Z",
    fill: "#205B95"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M65.5179 38.1992H59.0471V38.6204H65.5179V38.1992Z",
    fill: "#2769A0"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0928 38.4727V38.5458C16.3556 38.5848 17.702 38.6312 19.146 38.6862L18.9031 55.0745H43.2714L49.9831 38.4727H15.0928Z",
    fill: "#C4C5C6"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0928 38.5456C4.99117 38.231 0.604004 38.3857 0.604004 38.3857C1.68729 42.6443 7.03052 47.745 7.03052 47.745C8.96635 49.7405 10.5111 52.4966 11.6666 55.0743H18.9031L19.146 38.686C17.7024 38.6309 16.3556 38.5846 15.0928 38.5456Z",
    fill: "#C4C5C6"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M49.7966 38.8438L43.0857 55.4456H62.5238L62.9146 38.8438H49.7966Z",
    fill: "#C4C5C6"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M62.8637 38.043H0V42.3166H62.8637V38.043Z",
    fill: "#BEBEBF"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1631 40.6728C10.1631 41.2337 9.70786 41.6887 9.1467 41.6887C8.58519 41.6887 8.12964 41.2337 8.12964 40.6728C8.12964 40.1116 8.58519 39.6562 9.1467 39.6562C9.70786 39.6562 10.1631 40.1112 10.1631 40.6728Z",
    fill: "#11496E"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M9.14666 41.8633C8.48965 41.8633 7.95532 41.3296 7.95532 40.6732C7.95532 40.0165 8.48965 39.4824 9.14666 39.4824C9.80332 39.4824 10.3373 40.0165 10.3373 40.6732C10.3373 41.3296 9.80297 41.8633 9.14666 41.8633ZM9.14666 39.8312C8.68204 39.8312 8.30387 40.2092 8.30387 40.6735C8.30387 41.1376 8.6817 41.5152 9.14666 41.5152C9.61092 41.5152 9.98874 41.1376 9.98874 40.6735C9.98874 40.2088 9.61092 39.8312 9.14666 39.8312Z",
    fill: "white"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5728 40.6728C13.5728 41.2337 13.1172 41.6887 12.5571 41.6887C11.9956 41.6887 11.54 41.2337 11.54 40.6728C11.54 40.1116 11.9956 39.6562 12.5571 39.6562C13.1172 39.6562 13.5728 40.1112 13.5728 40.6728Z",
    fill: "#11496E"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5571 41.8633C11.9 41.8633 11.3657 41.3296 11.3657 40.6732C11.3657 40.0165 11.9 39.4824 12.5571 39.4824C13.213 39.4824 13.747 40.0165 13.747 40.6732C13.747 41.3296 13.213 41.8633 12.5571 41.8633ZM12.5571 39.8312C12.0924 39.8312 11.7143 40.2092 11.7143 40.6735C11.7143 41.1376 12.0924 41.5152 12.5571 41.5152C13.021 41.5152 13.3985 41.1376 13.3985 40.6735C13.3985 40.2088 13.021 39.8312 12.5571 39.8312Z",
    fill: "white"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M18.1173 40.6728C18.1173 41.2337 17.6618 41.6887 17.1009 41.6887C16.5398 41.6887 16.0842 41.2337 16.0842 40.6728C16.0842 40.1116 16.5398 39.6562 17.1009 39.6562C17.6618 39.6562 18.1173 40.1112 18.1173 40.6728Z",
    fill: "#11496E"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1009 41.8633C16.4442 41.8633 15.9099 41.3296 15.9099 40.6732C15.9099 40.0165 16.4442 39.4824 17.1009 39.4824C17.7576 39.4824 18.2915 40.0165 18.2915 40.6732C18.2915 41.3296 17.7576 41.8633 17.1009 41.8633ZM17.1009 39.8312C16.6366 39.8312 16.2585 40.2092 16.2585 40.6735C16.2585 41.1376 16.6366 41.5152 17.1009 41.5152C17.5652 41.5152 17.943 41.1376 17.943 40.6735C17.943 40.2088 17.5652 39.8312 17.1009 39.8312Z",
    fill: "white"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5274 40.6728C21.5274 41.2337 21.0719 41.6887 20.5118 41.6887C19.9495 41.6887 19.4937 41.2337 19.4937 40.6728C19.4937 40.1116 19.9495 39.6562 20.5118 39.6562C21.0722 39.6562 21.5274 40.1112 21.5274 40.6728Z",
    fill: "#11496E"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5117 41.8633C19.8544 41.8633 19.3193 41.3296 19.3193 40.6732C19.3193 40.0165 19.8544 39.4824 20.5117 39.4824C21.1677 39.4824 21.7017 40.0165 21.7017 40.6732C21.7017 41.3296 21.168 41.8633 20.5117 41.8633ZM20.5117 39.8312C20.0464 39.8312 19.6679 40.2092 19.6679 40.6735C19.6679 41.1376 20.0464 41.5152 20.5117 41.5152C20.9756 41.5152 21.3531 41.1376 21.3531 40.6735C21.3531 40.2088 20.9756 39.8312 20.5117 39.8312Z",
    fill: "white"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M26.0715 40.6728C26.0715 41.2337 25.616 41.6887 25.0558 41.6887C24.494 41.6887 24.0381 41.2337 24.0381 40.6728C24.0381 40.1116 24.494 39.6562 25.0558 39.6562C25.6163 39.6562 26.0715 40.1112 26.0715 40.6728Z",
    fill: "#11496E"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M25.0558 41.8633C24.3984 41.8633 23.8638 41.3296 23.8638 40.6732C23.8638 40.0165 24.3984 39.4824 25.0558 39.4824C25.7118 39.4824 26.2457 40.0165 26.2457 40.6732C26.2457 41.3296 25.7121 41.8633 25.0558 41.8633ZM25.0558 39.8312C24.5905 39.8312 24.2123 40.2092 24.2123 40.6735C24.2123 41.1376 24.5905 41.5152 25.0558 41.5152C25.5197 41.5152 25.8972 41.1376 25.8972 40.6735C25.8972 40.2088 25.5197 39.8312 25.0558 39.8312Z",
    fill: "white"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M29.4819 40.6728C29.4819 41.2337 29.0264 41.6887 28.4655 41.6887C27.9047 41.6887 27.4485 41.2337 27.4485 40.6728C27.4485 40.1116 27.9047 39.6562 28.4655 39.6562C29.0267 39.6562 29.4819 40.1112 29.4819 40.6728Z",
    fill: "#11496E"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M28.4655 41.8633C27.8085 41.8633 27.2742 41.3296 27.2742 40.6732C27.2742 40.0165 27.8085 39.4824 28.4655 39.4824C29.1222 39.4824 29.6561 40.0165 29.6561 40.6732C29.6561 41.3296 29.1222 41.8633 28.4655 41.8633ZM28.4655 39.8312C28.0009 39.8312 27.6227 40.2092 27.6227 40.6735C27.6227 41.1376 28.0009 41.5152 28.4655 41.5152C28.9298 41.5152 29.3076 41.1376 29.3076 40.6735C29.3076 40.2088 28.9298 39.8312 28.4655 39.8312Z",
    fill: "white"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0256 40.6728C34.0256 41.2337 33.5701 41.6887 33.0103 41.6887C32.4484 41.6887 31.9922 41.2337 31.9922 40.6728C31.9922 40.1116 32.4484 39.6562 33.0103 39.6562C33.5701 39.6562 34.0256 40.1112 34.0256 40.6728Z",
    fill: "#11496E"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M33.01 41.8633C32.3526 41.8633 31.8176 41.3296 31.8176 40.6732C31.8176 40.0165 32.3526 39.4824 33.01 39.4824C33.666 39.4824 34.1996 40.0165 34.1996 40.6732C34.1999 41.3296 33.666 41.8633 33.01 41.8633ZM33.01 39.8312C32.5447 39.8312 32.1662 40.2092 32.1662 40.6735C32.1662 41.1376 32.5447 41.5152 33.01 41.5152C33.4739 41.5152 33.851 41.1376 33.851 40.6735C33.8514 40.2088 33.4739 39.8312 33.01 39.8312Z",
    fill: "white"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M37.4357 40.6728C37.4357 41.2337 36.9808 41.6887 36.4204 41.6887C35.8585 41.6887 35.4033 41.2337 35.4033 40.6728C35.4033 40.1116 35.8585 39.6562 36.4204 39.6562C36.9808 39.6562 37.4357 40.1112 37.4357 40.6728Z",
    fill: "#11496E"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M36.4203 41.8633C35.7633 41.8633 35.229 41.3296 35.229 40.6732C35.229 40.0165 35.7633 39.4824 36.4203 39.4824C37.0763 39.4824 37.6099 40.0165 37.6099 40.6732C37.6099 41.3296 37.0763 41.8633 36.4203 41.8633ZM36.4203 39.8312C35.9557 39.8312 35.5776 40.2092 35.5776 40.6735C35.5776 41.1376 35.9557 41.5152 36.4203 41.5152C36.8843 41.5152 37.2614 41.1376 37.2614 40.6735C37.2614 40.2088 36.8843 39.8312 36.4203 39.8312Z",
    fill: "white"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M42.7759 40.6728C42.7759 41.2337 42.3203 41.6887 41.7595 41.6887C41.198 41.6887 40.7424 41.2337 40.7424 40.6728C40.7424 40.1116 41.198 39.6562 41.7595 39.6562C42.3203 39.6562 42.7759 40.1112 42.7759 40.6728Z",
    fill: "#11496E"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M41.7595 41.8633C41.1024 41.8633 40.5681 41.3296 40.5681 40.6732C40.5681 40.0165 41.1024 39.4824 41.7595 39.4824C42.4161 39.4824 42.9501 40.0165 42.9501 40.6732C42.9501 41.3296 42.4161 41.8633 41.7595 41.8633ZM41.7595 39.8312C41.2948 39.8312 40.9167 40.2092 40.9167 40.6735C40.9167 41.1376 41.2948 41.5152 41.7595 41.5152C42.2237 41.5152 42.6015 41.1376 42.6015 40.6735C42.6015 40.2088 42.2237 39.8312 41.7595 39.8312Z",
    fill: "white"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M46.1858 40.6728C46.1858 41.2337 45.7303 41.6887 45.1701 41.6887C44.6086 41.6887 44.1531 41.2337 44.1531 40.6728C44.1531 40.1116 44.6086 39.6562 45.1701 39.6562C45.7306 39.6562 46.1858 40.1112 46.1858 40.6728Z",
    fill: "#11496E"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M45.1701 41.8633C44.5131 41.8633 43.9788 41.3296 43.9788 40.6732C43.9788 40.0165 44.5131 39.4824 45.1701 39.4824C45.8264 39.4824 46.36 40.0165 46.36 40.6732C46.36 41.3296 45.8264 41.8633 45.1701 41.8633ZM45.1701 39.8312C44.7055 39.8312 44.3273 40.2092 44.3273 40.6735C44.3273 41.1376 44.7055 41.5152 45.1701 41.5152C45.634 41.5152 46.0115 41.1376 46.0115 40.6735C46.0115 40.2088 45.634 39.8312 45.1701 39.8312Z",
    fill: "white"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M50.73 40.6728C50.73 41.2337 50.2744 41.6887 49.7136 41.6887C49.1518 41.6887 48.6973 41.2337 48.6973 40.6728C48.6973 40.1116 49.1518 39.6562 49.7136 39.6562C50.2748 39.6562 50.73 40.1112 50.73 40.6728Z",
    fill: "#11496E"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M49.7136 41.8633C49.0569 41.8633 48.5229 41.3296 48.5229 40.6732C48.5229 40.0165 49.0569 39.4824 49.7136 39.4824C50.3703 39.4824 50.9042 40.0165 50.9042 40.6732C50.9042 41.3296 50.3703 41.8633 49.7136 41.8633ZM49.7136 39.8312C49.2493 39.8312 48.8715 40.2092 48.8715 40.6735C48.8715 41.1376 49.2493 41.5152 49.7136 41.5152C50.1779 41.5152 50.5557 41.1376 50.5557 40.6735C50.5557 40.2088 50.1779 39.8312 49.7136 39.8312Z",
    fill: "white"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M55.23 40.6553C55.23 41.2162 54.7776 41.6711 54.2196 41.6711C53.6612 41.6711 53.2095 41.2162 53.2095 40.6553C53.2095 40.094 53.6615 39.6387 54.2196 39.6387C54.7779 39.6387 55.23 40.0937 55.23 40.6553Z",
    fill: "#11496E"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M54.2195 41.8457C53.5663 41.8457 53.0352 41.312 53.0352 40.6556C53.0352 39.9989 53.5663 39.4648 54.2195 39.4648C54.8727 39.4648 55.4042 39.9989 55.4042 40.6556C55.4042 41.312 54.8727 41.8457 54.2195 41.8457ZM54.2195 39.8132C53.7587 39.8132 53.3837 40.1912 53.3837 40.6556C53.3837 41.1197 53.7587 41.4973 54.2195 41.4973C54.6807 41.4973 55.0557 41.1197 55.0557 40.6556C55.0557 40.1912 54.6807 39.8132 54.2195 39.8132Z",
    fill: "white"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M81.1157 38.4913C81.1157 38.4913 76.0896 38.0812 64.3743 38.0422C63.7901 38.0401 63.1937 38.0391 62.5761 38.0391L62.1941 56.1303H69.585C70.8151 53.446 72.4076 50.6303 74.3361 48.5885C74.3361 48.5885 79.8707 43.1627 81.1157 38.4913Z",
    fill: "#D1D2D3"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M81.291 38.043H0V39.0376H81.291V38.043Z",
    fill: "#A4A4A5"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M81.2907 38.0391H62.5762V39.0382H81.2907V38.0391Z",
    fill: "#BEBEBF"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6693 44.7793H9.47314V46.0913H15.6693V44.7793Z",
    fill: "#F2F3F4"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6696 44.7793H9.91016V46.0913H15.6696V44.7793Z",
    fill: "#F2F3F4"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8357 44.7793H17.6382V46.0913H23.8357V44.7793Z",
    fill: "#F2F3F4"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8361 44.7793H18.0767V46.0913H23.8361V44.7793Z",
    fill: "#F2F3F4"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M33.1661 44.7793H26.97V46.0913H33.1661V44.7793Z",
    fill: "#F2F3F4"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M33.166 44.7793H27.407V46.0913H33.166V44.7793Z",
    fill: "#F2F3F4"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M0.815238 35.7422H0.0310059V38.268H0.815238V35.7422Z",
    fill: "#A4A4A5"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M81.1987 35.7422H0.0310059V36.4825H81.1987V35.7422Z",
    fill: "#A4A4A5"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M81.1987 36.2422H0.0310059V36.5376H81.1987V36.2422Z",
    fill: "#BEBEBF"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M81.315 35.7266H80.7051V38.2523H81.315V35.7266Z",
    fill: "#BEBEBF"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M66.2801 54.4794C63.8124 52.7839 60.2342 51.2572 57.1499 53.9705C54.0653 56.6833 51.4752 55.3278 48.6373 53.9705C45.7991 52.6135 43.7016 52.2745 40.1248 54.3098C36.5459 56.344 34.5717 56.1743 31.364 54.4794C28.1563 52.7839 26.1829 52.7839 23.7151 53.9705C21.2471 55.1574 18.7797 54.4794 15.6958 53.6304C12.6108 52.7839 11.6244 51.2572 8.16922 53.6304C7.06921 54.3878 6.15742 54.6784 5.42407 54.7244V58.5252C6.15742 58.4792 7.06921 58.189 8.16922 57.432C11.6244 55.0591 12.6108 56.5833 15.6958 57.432C18.7797 58.2799 21.2471 58.9586 23.7151 57.7713C26.1829 56.5837 28.1563 56.5837 31.364 58.28C34.5717 59.9766 36.5459 60.1452 40.1248 58.111C43.7016 56.0764 45.7991 56.4157 48.6373 57.7713C51.4752 59.1286 54.0653 60.4845 57.1499 57.7713C60.2346 55.0595 63.8124 56.5837 66.2801 58.28C68.3048 59.6721 71.5749 59.3498 73.9109 58.3465V54.5463C71.5749 55.549 68.3045 55.8709 66.2801 54.4794Z",
    fill: "#9CDCFE"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M66.2801 58.2796C63.8124 56.5833 60.2342 55.0592 57.1499 57.771C54.0653 60.4842 51.4752 59.1283 48.6373 57.771C45.7991 56.4151 43.7016 56.0761 40.1248 58.1106C36.5459 60.1452 34.5717 59.9763 31.364 58.2796C28.1563 56.5833 26.1829 56.5833 23.7151 57.771C21.2471 58.9583 18.7797 58.2796 15.6958 57.4317C12.6108 56.583 11.6244 55.0588 8.16922 57.4317C7.06921 58.1887 6.15742 58.4789 5.42407 58.5249V62.9305C6.15742 62.8849 7.06921 62.594 8.16922 61.8384C11.6244 59.4638 12.6108 60.99 15.6958 61.8384C18.7797 62.686 21.2471 63.3639 23.7151 62.1777C26.1829 60.9904 28.1563 60.9904 31.364 62.686C34.5717 64.3819 36.5459 64.5516 40.1248 62.5163C43.7016 60.4824 45.7991 60.8211 48.6373 62.1777C51.4752 63.5339 54.0653 64.8898 57.1499 62.1777C60.2346 59.4638 63.8124 60.9904 66.2801 62.686C68.3048 64.0774 71.5749 63.7558 73.9109 62.7522V58.3465C71.5749 59.3495 68.3045 59.6718 66.2801 58.2796Z",
    fill: "#86D5FE"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M46.0251 24.377H33.0745V30.9112H46.0251V24.377Z",
    fill: "#46556B"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M52.6726 24.377H46.0251V30.9112H52.6726V24.377Z",
    fill: "#506A89"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M33.4683 24.5957H33.2219V30.9119H33.4683V24.5957Z",
    fill: "#3B495B"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M34.3546 24.5957H34.1089V30.9119H34.3546V24.5957Z",
    fill: "#3B495B"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M35.5363 24.5957H35.2905V30.9119H35.5363V24.5957Z",
    fill: "#3B495B"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M36.7178 24.5957H36.4724V30.9119H36.7178V24.5957Z",
    fill: "#3B495B"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M38.1951 24.5957H37.9497V30.9119H38.1951V24.5957Z",
    fill: "#3B495B"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M39.6732 24.5957H39.4275V30.9119H39.6732V24.5957Z",
    fill: "#3B495B"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M41.4451 24.5957H41.1997V30.9119H41.4451V24.5957Z",
    fill: "#3B495B"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M42.9229 24.5957H42.6765V30.9119H42.9229V24.5957Z",
    fill: "#3B495B"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M44.6954 24.5957H44.4497V30.9119H44.6954V24.5957Z",
    fill: "#3B495B"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M47.3547 24.5957H47.1086V30.9119H47.3547V24.5957Z",
    fill: "#577CA0"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M48.832 24.5957H48.5859V30.9119H48.832V24.5957Z",
    fill: "#577CA0"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M50.3091 24.5957H50.063V30.9119H50.3091V24.5957Z",
    fill: "#577CA0"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M51.7866 24.5957H51.5413V30.9119H51.7866V24.5957Z",
    fill: "#577CA0"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M52.6789 24.2246H46.0129V24.6078H52.6789V24.2246Z",
    fill: "#3E4E5E"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M46.0129 24.2246H33.0623V24.6165H46.0129V24.2246Z",
    fill: "#394656"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M46.0129 30.7578H33.0623V31.1504H46.0129V30.7578Z",
    fill: "#394656"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M52.6706 30.7578H46.0039V31.1424H52.6706V30.7578Z",
    fill: "#3E4E5E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarineopenpolicyicon);
export default __webpack_public_path__ + "static/media/marine open policy icon.790e9d0d07de5ae03e0acadeb7d2b7c8.svg";
export { ForwardRef as ReactComponent };